import { tokenString } from "@/proxy-utils"

import { isClientSide } from "@/lib/is-client-side"
import { isEmbedded } from "@/lib/is-embedded"
import { webStorage } from "@/lib/web-storage"

// EventSource cannot send the Authorization header used by our Axios client.
// Both ordinary and ephemeral chat streams must forward embedded credentials.
export function eventStreamUrl({
  streamId,
  chatId,
  lastEventId,
}: {
  streamId: string
  chatId?: number
  lastEventId?: string
}): string {
  const params = new URLSearchParams()
  if (chatId !== undefined) params.set("chat_id", String(chatId))
  params.set("stream_id", streamId)
  if (lastEventId) params.set("last_event_id", lastEventId)

  if (isEmbedded() && isClientSide()) {
    const token = webStorage.getItem("embedded.mindtrip.auth_token")
    const legacyToken = webStorage.getItem("embedded.mindtrip.auth")
    if (token) {
      params.set("mindtrip.auth_token", token)
    } else if (legacyToken) {
      params.set("mindtrip.auth", tokenString(legacyToken))
    }
  }

  return `/api/events?${params}`
}
